/** What each purchase order status means across the web and native apps: the
 *  one definition of an "open" order, and the label each status shows. Kept
 *  apart from the register model so the delivery check can read it without an
 *  import cycle. */
import type { ProjectPurchaseOrderStatus } from '../../types/projectProcurement';

/** Issued to the merchant and still waiting on goods. A draft has not been
 *  sent, so it commits nothing; received and cancelled orders are settled. */
export const OPEN_PURCHASE_ORDER_STATUSES: ReadonlySet<ProjectPurchaseOrderStatus> = new Set<ProjectPurchaseOrderStatus>([
  'issued',
  'acknowledged',
  'partially-received',
]);

export function isOpenPurchaseOrder(status: string | null | undefined): boolean {
  return OPEN_PURCHASE_ORDER_STATUSES.has(status as ProjectPurchaseOrderStatus);
}

export const PURCHASE_ORDER_STATUS_LABEL: Record<ProjectPurchaseOrderStatus, string> = {
  draft: 'Draft',
  issued: 'Issued',
  acknowledged: 'Acknowledged',
  'partially-received': 'Part received',
  received: 'Received',
  cancelled: 'Cancelled',
};

export function purchaseOrderStatusLabel(status: string | null | undefined): string {
  if (!status) return 'Issued';
  return PURCHASE_ORDER_STATUS_LABEL[status as ProjectPurchaseOrderStatus]
    ?? status.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
